import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { emailSignInStart, googleSignInStart } from '../../redux/User/user.actions';
import ReactLoading from 'react-loading'

import './styles.scss';

import AuthWrapper from '../AuthWrapper';
import FormInput from '../forms/FormInput';
import Button from '../forms/Button';

const mapState = ({ user }) => ({
  currentUser: user.currentUser
});

const SignIn = props => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [click, setClick] = useState(false);
  const [errors, setErrors] = useState([]);
  const { currentUser, userErr } = useSelector(mapState);

  const handleClick = () => setClick(!click);

  useEffect(() => {
    if (currentUser) {
      resetForm();
      history.goBack();
    }

  }, [currentUser]);

  useEffect(() => {
    if (Array.isArray(userErr) && userErr.length > 0) {
      setErrors(userErr);
      setClick(false)
    }

  }, [userErr]);

  const resetForm = () => {
    setEmail('');
    setPassword('');
  };

  const handleSubmit = e => {
    // setbtnloading(false);
    e.preventDefault();
    dispatch(emailSignInStart({ email, password }));
  }

  const handleGoogleSignIn = () => {
    dispatch(googleSignInStart());
  }

  const configAuthWrapper = {
    headline: 'LogIn'
  };

  return (
    <AuthWrapper {...configAuthWrapper}>
      <div className="formWrap">
        <span className="txt">
          Welcome back! Sign in to your account
        </span>

        {errors.length > 0 && (
          <ul className="err" >
            {errors.map((err, index) => {
              return (
                <li key={index}>
                  {err}
                </li>
              );
            })}
          </ul>
        )}

        <form onSubmit={handleSubmit}>

          <FormInput
            type="email"
            name="email"
            value={email}
            placeholder="Email"
            handleChange={e => setEmail(e.target.value)}
          />

          <FormInput
            type="password"
            name="password"
            value={password}
            placeholder="Password"
            handleChange={e => setPassword(e.target.value)}
          />

          <div className="links flex">
            <li>
              <Link to="/">
                Continue Shopping
              </Link>
            </li>

            <li>
              <Link to="/recovery">
                Forgot Password?
              </Link>
            </li>
          </div>

          <Button type="submit" onClick={handleClick}>
            <span className={click ? 'span active' : 'span'}>
              Login
            </span>

            <ReactLoading className={click ? 'loader' : 'loader active'} type="bubbles" color={"#fff"} height={20} width={80} />
          </Button>

          <div>

          </div>

          <div className="socialSignin">
            <div className="row">
              <Button onClick={handleGoogleSignIn}>
                Sign in with Google
              </Button>
            </div>
          </div>

          <div className="links">
            <span>New here?</span>
            <Link to="/registration">
              Register
            </Link>
            {/* {` | `} */}

          </div>

        </form>
      </div>
    </AuthWrapper>
  );
}

export default SignIn;
